const config = {
  menu: {
    user: [
      { caption: "Fichas de costo", link: "costsheet" },
      { caption: "Elementos", link: "costelement" },
    ],
    admin: [
      { caption: "Fichas de costo", link: "costsheet" },
      { caption: "Elementos", link: "costelement" },
      { caption: "Configuración", link: "configuration" },
      { caption: "Usuarios", link: "user" },
    ],
    sa: [
      { caption: "Empresas", link: "enterprise" },
      { caption: "Usuarios", link: "user" },
    ],
  },
  apiUrl: process.env.REACT_APP_API_URL,
  paginationSize: 8, // Pages to show to left or right of current page
  itemsPerPage: 10,
  messages: {
    noRecords: "No se encontraron registros...",
  },
};

export default config;
